import { ConversionLogsTable } from "components/Tables/ConversionLogsTable/ConversionLogsTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout/conversion/")({
    component: ConversionLogsPage,
    staticData: {
        permissions: [PermissionEnum.ConversionConversionLogView],
        showInSideMenu: false,
        label: "pages.log.conversion.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.conversion.title"),
        };
    },
});

function ConversionLogsPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <ConversionLogsTable type={"conversion"} />
        </TenantPage>
    );
}
